import { CurrencyPipe } from "@angular/common";
import { Component, Input, OnInit, inject, input, output } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { FloorplanItem } from "@domain/project/floorplan/floorplan-item";
import { FloorplanSidesheetExtent } from "@domain/project/floorplan/floorplan-sidesheet-extent";
import { FloorplanSignalElement } from "@domain/project/floorplan/floorplan-signal-element";
import { FloorplanItemDetailsComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-item-details/floorplan-item-details.component";
import { FloorplanSignalElementDetailFormComponent } from "@project/floorplanner/floorplan-additional-notes/floorplan-signal-element-detail-form/floorplan-signal-element-detail-form.component";
import { FloorplanItemGroupComponent } from "@project/floorplanner/floorplan-item-group/floorplan-item-group.component";
import { ProjectStateService } from "@project/project-state.service";
import { Observable } from "rxjs";

@Component({
  selector: " app-signal-notes",
  templateUrl: "./signal-notes.component.html",
  imports: [UiKitModule, FloorplanItemDetailsComponent, FloorplanItemGroupComponent, FloorplanSignalElementDetailFormComponent],
  providers: [CurrencyPipe],
  standalone: true,
})
export class SignalNotesComponent implements OnInit {
  private projectStateService = inject(ProjectStateService);

  @Input({ required: true }) set floorplanItem(item: FloorplanItem) {
    this.signalElement = item as FloorplanSignalElement;
  }
  readonly extent = input.required<FloorplanSidesheetExtent>();
  readonly toggleExtendedButtonClicked = output<void>();

  protected signalElement!: FloorplanSignalElement;
  protected isDiscontinued$!: Observable<boolean>;

  ngOnInit() {
    this.isDiscontinued$ = this.projectStateService.isConfigDiscontinued(this.signalElement.config.id);
  }
}
